import React from 'react';

import {PromoPageListItem} from '../PromoPageListItem';

import {i18n} from '../i18n';
import {PRIVACY_URL, TERMS_URL} from '../constants';
import './PromoPageFooter.scss';

import {cnPromoPageFooter} from './PromoPageFooter.classname';
const currentYear = new Date().getFullYear();

interface PromoPageFooterProps {
    lang?: 'ru' | 'en';
}

export const PromoPageFooter: React.FC<PromoPageFooterProps> = ({lang}) => {
    return (
        <div className={cnPromoPageFooter()}>
            <ul className={cnPromoPageFooter('List')}>
                <PromoPageListItem
                    text={i18n('label-item-privacy')}
                    href={`${PRIVACY_URL}?lang=${lang}`}
                    className={cnPromoPageFooter('Link')}
                />
                <PromoPageListItem
                    text={i18n('label-item-terms')}
                    href={`${TERMS_URL}?lang=${lang}`}
                    className={cnPromoPageFooter('Link')}
                />
            </ul>
            <div className={cnPromoPageFooter('Copyright')}>
                &copy;&nbsp;{currentYear}&nbsp;{i18n('cloud-name')}
            </div>
        </div>
    );
};
